module.exports = __webpack_public_path__ + "img/16l004-02.e829578e.jpg";